import { Routes, Route } from "react-router-dom"
import Layout from "./layout"
import Otp from "@/features/otp/otp"
import Phone from "@/features/phone/phone"
import Success from "@/features/success/success"
import Error from "@/features/error/error"
import Tnc from "@/features/tnc/tnc"
import PrivatePolicy from "@/features/privatePolicy/privatePolicy"

export default function Router() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Phone />} />
          <Route path="otp" element={<Otp />} />
          <Route path="success" element={<Success />} />
          <Route path="error" element={<Error />} />
          <Route path="tnc" element={<Tnc />} />
          <Route path="privatePolicy" element={<PrivatePolicy />} />
        </Route>
      </Routes>
    </div>
  )
}
